import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface RequestSubmitConfirmDialogProps {
  open: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onConfirm: () => void;
}

export const RequestSubmitConfirmDialog: React.FC<
  RequestSubmitConfirmDialogProps
> = ({ open, isSubmitting, onBack, onConfirm }) => (
  <Dialog
    open={open}
    onClose={isSubmitting ? undefined : onBack}
    aria-labelledby="research-request-confirm-title"
  >
    <DialogTitle id="research-request-confirm-title">
      不動産調査依頼の確認
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        表示内容で依頼します。依頼後、担当者から入力いただいたメールアドレスへご連絡します。
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onBack} disabled={isSubmitting}>
        戻る
      </Button>
      <Button onClick={onConfirm} variant="contained" disabled={isSubmitting}>
        依頼する
      </Button>
    </DialogActions>
  </Dialog>
);
